import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_GetMessagingSessionEndpointCommand, se_GetMessagingSessionEndpointCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class GetMessagingSessionEndpointCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "GetMessagingSessionEndpoint", {})
    .n("ChimeSDKMessagingClient", "GetMessagingSessionEndpointCommand")
    .f(void 0, void 0)
    .ser(se_GetMessagingSessionEndpointCommand)
    .de(de_GetMessagingSessionEndpointCommand)
    .build() {
}
